import { selectHasReadEventsPermission } from 'app/modules/session/selectors';
import { useSelector } from 'react-redux';

import { U21Chip, U21ChipProps } from 'app/shared/u21-ui/components';
import { useToggleActionEventSidebar } from 'app/modules/sidebar/hooks';
import { IconLock } from '@u21/tabler-icons';

export interface U21ActionEventChipProps extends Omit<
  U21ChipProps,
  'id' | 'children'
> {
  id: string | number;
  label: string;
  // External (customer) id. When provided, the sidebar resolves the action event
  // via the hashed-id lookup in PG cache mode.
  externalId?: string;
}

export const U21ActionEventChip = (props: U21ActionEventChipProps) => {
  const { id, label, externalId, onClick, ...rest } = props;
  const hasReadEventsPermission = useSelector(selectHasReadEventsPermission);
  const toggleActionEventSidebar = useToggleActionEventSidebar();
  return (
    <U21Chip
      onClick={
        hasReadEventsPermission
          ? (e) => {
              if (onClick) {
                onClick(e);
              }

              e.stopPropagation();
              toggleActionEventSidebar(
                id,
                e,
                externalId ? { externalId } : undefined,
              );
            }
          : undefined
      }
      icon={<IconLock />}
      {...rest}
    >
      {label}
    </U21Chip>
  );
};
